import type {
  BookingDropOffList,
  BookingDropOffReason,
  SetBookingDropOffReason,
} from "@care-by-ella/contracts";
import { API_BASE, apiFetch, withCredentials } from "./api";
import { commonHeaders, jsonOr401 } from "./clinician-api";

// TES-1102 S3 — booking diagnostics, admin only. The reason routes are
// patient-scoped and answer 403 `support_reason_required` without today's
// support access reason for that patient. PDL purpose: administration.

const BASE = `${API_BASE}/employee-api/v1/booking-diagnostics`;
const reasonUrl = (patientId: string) =>
  `${BASE}/patients/${encodeURIComponent(patientId)}/drop-off-reason`;

function headers(): Record<string, string> {
  return { ...commonHeaders(), "X-Access-Purpose": "administration" };
}

/** `from`/`to` are inclusive Stockholm days, YYYY-MM-DD. */
export async function fetchBookingDropOffs(
  from: string,
  to: string,
): Promise<BookingDropOffList> {
  const qs = new URLSearchParams({ from, to });
  const res = await apiFetch(`${BASE}?${qs}`, {
    headers: headers(),
    ...withCredentials,
  });
  return jsonOr401(res);
}

export async function fetchDropOffReason(
  patientId: string,
): Promise<{ reason: BookingDropOffReason | null }> {
  const res = await apiFetch(reasonUrl(patientId), {
    headers: headers(),
    ...withCredentials,
  });
  return jsonOr401(res);
}

export async function saveDropOffReason(
  patientId: string,
  body: SetBookingDropOffReason,
): Promise<{ reason: BookingDropOffReason }> {
  const res = await apiFetch(reasonUrl(patientId), {
    method: "PUT",
    headers: headers(),
    body: JSON.stringify(body),
    ...withCredentials,
  });
  return jsonOr401(res);
}
